import axios from "axios";
import { BASE_URL, SUB_URL } from "./BaseUrl";

// const BASE_URL = `https://unit40.smartekanban.in/index.php/Apiv4`;

const EOLService = {
    getKanbanDataById: async (kanbanId) => {
        console.log("Fetching Kanban data for ID:", kanbanId);

        try {
            const formData = new FormData();
            formData.append('kb_number', kanbanId.kb_number);
            // 000A00041

            const response = await axios.post(`${BASE_URL.BASE_URL}${BASE_URL.API_URL}${SUB_URL.get_kanban_data}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });

            console.log(response.data);
            return response.data;
        } catch (error) {
            console.error("Error fetching Kanban data:", error);
            return [];
        }
    },

    add_eol_dispatch: async (size, userData, dispatchArea, editValue, selectedBin, binFull) => {
        console.log(binFull);
        
        try {
            const formData = new FormData();
            formData.append('kanban_no', editValue[0].kanban_no);
            formData.append('dispatch_area', dispatchArea);
            formData.append('added_by', userData.su_id);
            formData.append('size_name', size);
            formData.append('bin_id', selectedBin || null);
            formData.append('bin_full', binFull || null);

            const response = await axios.post(`${BASE_URL.BASE_URL}${BASE_URL.API_URL}${SUB_URL.add_eol_dispatch}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });

            console.log(response.data);
            return response.data;

        } catch (error) {
            console.error("Error fetching Kanban data:", error);
            return [];
        }
    },
};

export default EOLService;
